const AFRAME = window.AFRAME

const clickable = AFRAME.registerComponent('clickable', {
  init() {
    this.el.addEventListener('click', (event) => {
      console.log('clicked', this.el)
      // use for click events
    })
  }
})

export default clickable
